import Component from 'gia/Component';
import { gsap } from 'gsap';
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin';

gsap.registerPlugin(ScrambleTextPlugin)


export default class Intro extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      word: {}
    };
  }

  mount() {

    let that = this;

    let words = [
      {
        text: "story",
        chars: "01",
        newClass: "text-emerald-500"
      },
      {
        text: "email",
        chars: "01",
        newClass: "text-blue-300"
      },
      {
        text: "song",
        chars: "01",
        newClass: "text-indigo-300"
      },
      {
        text: "video game",
        chars: "01",
        newClass: "text-lime-400"
      },
      {
        text: "letter",
        chars: "01",
        newClass: "text-red-500"
      },

      {
        text: "photograph",
        chars: "01",
        newClass: "text-rose-900"
      },
      {
        text: "book",
        chars: "01",
        newClass: "text-teal-300"
      },
      {
        text: "poem",
        chars: "❤️💗01",
        newClass: "text-red-300"
      },
      {
        text: "play",
        chars: "01",
        newClass: "text-lime-800"
      },
      {
        text: "text message",
        chars: "01",
        newClass: "text-cyan-500"
      },
      {
        text: "course",
        chars: "01",
        newClass: "text-pink-400"
      },
      {
        text: "idea",
        chars: "01",
        newClass: "text-amber-600"
      },
    ];

    let timeline = gsap.timeline({
      repeat: -1,
      repeatDelay: 1
    });

    words.forEach((word,index) => {
      timeline.to(this.ref.word, {
        duration: 2,
        scrambleText: {
          text: word.text,
          chars: word.chars,
          revealDelay: 0.5,
          speed: 0.3,
          newClass: word.newClass
        }
      },index > 0 ? '+=2' : '');
    })


  }


}